import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  imports: [CommonModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SignaturePadComponent),
      multi: true,
    },
  ],
})
export class SignaturePadComponent implements ControlValueAccessor {
  signaturePad!: SignaturePad;
  @ViewChild('canvas') canvasEl!: ElementRef;
  @Output() signatureChanged = new EventEmitter<string>();
  constructor() {}
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: string): void {
    if (this.signaturePad) {
      const base64Data = this.signaturePad.toDataURL();

      this.onChange(base64Data);
      if (this.signaturePad && value) this.signaturePad.fromDataURL(value);
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  ngAfterViewInit() {
    const canvas = this.canvasEl.nativeElement;

    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
    this.signaturePad.addEventListener('endStroke', () => {
      const base64Data = this.signaturePad.toDataURL();
      this.onChange(base64Data);

      this.signatureChanged.emit(base64Data);
    });
  }
  clearPad() {
    this.signaturePad.clear();
    this.signatureChanged.emit('');
  }
}
